<template>
  <div class="details">
    <el-row :gutter="40">
      <el-col :span="10">
        <form-title class="flex">
          基本信息
          <el-button
            type="primary"
            @click="liveHandler"
          >
            {{ result.liveStatus !== 10 ? '开启直播': '关闭直播' }}
          </el-button>
        </form-title>
        <info-panel class="info">
          <el-row>
            <el-col>
              <info-item label="课程名称">
                {{ result.courseName }}
              </info-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <info-item label="课程类型">
                {{ courseTypeList.filter(v => v.value === result.courseType).map(v=>v.label).join('') }}
              </info-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <info-item label="课程章节">
                {{ result.chapterList.map(v=>v.value).join(' , ') }}
              </info-item>
            </el-col>
          </el-row>
        </info-panel>
        <form-title>
          直播事件列表
        </form-title>
        <data-table
          :data="eventList"
          scroll
          class="event-list"
          :table-column="tableColumnEvent"
        />
      </el-col>
      <el-col :span="14">
        <form-title
          ref="sad"
          class="flex"
        >
          直播
          <div class="btns">
            <el-button
              type="primary"
              @click="openPushDialog"
            >
              获取推流链接
            </el-button>
            <el-button
              type="primary"
              @click="sendLiveNotice"
            >
              发送上课通知
            </el-button>
          </div>
        </form-title>
        <info-panel class="video-content">
          <liveFlv
            v-if="pullUrl"
            :url="pullUrl"
          />
        </info-panel>
        <form-title>聊天室</form-title>
        <info-panel>
          <chatRoom :id="this.$route.params.id" />
        </info-panel>
      </el-col>
    </el-row>
    <form-title class="flex">
      直播视频记录
      <el-button
        type="primary"
        @click="openLiveVideoDialog({})"
      >
        上传直播视频
      </el-button>
    </form-title>
    <data-table
      :data="videoLiveList"
      :table-column="tableColumn"
      @buttonClick="buttonClick"
    />
    <video-dialog
      :dialog-visible.sync="vedioVisible"
      :item="activeVideoItem"
    />
    <custome-Dialog
      :dialog-visible.sync="dialogVisible"
      confirm-text="确认"
      title="推流地址"
      width="35%"
      :confirm-disable="false"
      class="push-url"
      @confirm="dialogVisible = false"
      @close="dialogVisible = false"
    >
      <info-item
        label="服务器地址"
        class="m-b-20"
      >
        <span>
          {{ pushUrl.pushServer }}
        </span>
        <span
          ref="copy1"
          class="copy"
          @click="copy(pushUrl.pushServer,'copy1')"
        >复制地址</span>
      </info-item>
      <info-item label="推流秘钥">
        <span>
          {{ pushUrl.pushSecret }}
        </span>
        <span
          ref="copy2"
          class="copy"
          @click="copy(pushUrl.pushSecret,'copy2')"
        >复制地址</span>
      </info-item>
    </custome-Dialog>
    <custome-Dialog
      :dialog-visible.sync="videoUrlDialogVisible"
      confirm-text="确认"
      title="视频地址"
      width="55%"
      :confirm-disable="false"
      class="push-url"
      @confirm="videoUrlDialogVisible = false"
      @close="videoUrlDialogVisible = false"
    >
      <info-item label="视频地址">
        <span>
          {{ activeVideoItem.url }}
        </span>
        <span
          ref="copy3"
          class="copy"
          @click="copy(activeVideoItem.url,'copy3')"
        >复制地址</span>
      </info-item>
    </custome-Dialog>
    <video-name-dialog
      :dialog-visible.sync="videoNameDialogVisible"
      :item="activeVideoItem"
      @confirm="setVideoName"
    />
    <!-- 线上直播上传 -->
    <live-video-dialog
      :dialog-visible.sync="liveVideoDialogVisible"
      :item="activeLiveVideoItem"
      @confirm="getInfo"
      @close="()=> activeLiveVideoItem = {}"
    />
    <!-- 线上直播上传 -->
  </div>
</template>
<script>
import Clipboard from 'clipboard';
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import untils from '@/util';
import customeDialog from '@/components/common/dialog.vue';
import liveFlv from '@/components/common/liveFlv.vue';
import chatRoom from '@/components/common/chatRoom/chatRoom.vue';
import dataTable from '@/components/common/dataTable.vue';
import axClient from '@/services';
import types, { courseTypeList, liveEventList } from '@/config';
import videoDialog from '@/components/common/videoDialog.vue';
import videoNameDialog from '@/components/common/videoNameDialog.vue';
import liveVideoDialog from '@/components/common/liveVideoDialog.vue';

export default {
  name: 'OrderDetails',
  components: {
    dataTable,
    formTitle,
    infoPanel,
    infoItem,
    videoDialog,
    customeDialog,
    liveFlv,
    chatRoom,
    videoNameDialog,
    liveVideoDialog,
  },
  data() {
    return {
      types,
      untils,
      courseTypeList,
      vedioVisible: false,
      dialogVisible: false,
      videoUrlDialogVisible: false,
      videoNameDialogVisible: false,
      liveVideoDialogVisible: false,
      activeVideoItem: { url: '', name: null, id: null },
      activeLiveVideoItem: null,
      pushUrl: {},
      pullUrl: null,
      col: 5,
      result: { chapterList: [] },
      videoLiveList: [],
      eventList: [],
      tableColumn: [
        {
          key: 'createTime',
          label: '日期',
          width: '150px',
          dataType: 'time',
        },
        {
          key: 'formateSeconds',
          label: '视频时长',
          dataType: 'text',
          width: '120px',
        },
        {
          key: 'liveVideoName',
          label: '视频名称',
          dataType: 'text',
        },
        {
          key: 'control',
          label: '操作',
          width: '450px',
          dataType: 'component',
          renderProps: [
            {
              text: '播放视频', renderKey: null, type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
            {
              text: '下载视频', renderKey: null, type: 'info', eventIndex: 2, disableKey: null,
            },
            {
              text: '复制视频地址', renderKey: null, type: 'success', eventIndex: 3, disableKey: null,
            },
            {
              text: '编辑视频', renderKey: null, eventIndex: 4, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      tableColumnEvent: [
        {
          key: 'createTime',
          label: '日期',
          width: '180px',
          dataType: 'time',
        },
        {
          key: 'eventType',
          label: '事件类型',
          dataType: 'function',
          renderProps: '',
          render: (key) => liveEventList.filter((item) => item.value === key),
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['socketMsg']),
  },
  watch: {
    socketMsg(value) {
      // 数据变化插入一条 最多一百条 只有图片和文字信息才会收集
      if (value.messageType === 40) {
        this.listEvent();
      }
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 修改视频名称
    setVideoName() {
      this.listLiveRecordVideo();
    },
    // 获取详情
    async getInfo() {
      this.result = await axClient.live.getLiveRoomInfo({ id: this.$route.params.id });
      this.listLiveRecordVideo();
      this.listEvent();
      this.getPushUrl();
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.openVideoDialog(item);
          break;
        case 1:
          this.deleteVideo(item);
          break;
        case 2:
          this.downloadVideo(item);
          break;
        case 3:
          this.activeVideoItem.url = item.liveVideoUrl;
          this.videoUrlDialogVisible = true;
          break;
        case 4:
          // this.activeVideoItem.name = item.liveVideoName;
          // this.activeVideoItem.id = item.id;
          // this.videoNameDialogVisible = true;
          this.openLiveVideoDialog(item);
          break;
        default:
          break;
      }
    },
    // 打开视频播放弹窗
    openVideoDialog(item) {
      this.vedioVisible = true;
      this.activeVideoItem.url = item.liveVideoUrl;
    },
    // 关闭直播 开启直播
    liveHandler() {
      let confirmText = '';
      let data = null;
      if (this.result.liveStatus === 10) {
        // 直播中
        confirmText = '关闭';
      } else {
        // 直播已关闭
        confirmText = '开启';
      }
      this.$confirm(`确定${confirmText}直播？`, `${confirmText}直播`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        if (this.result.liveStatus === 10) {
          data = await axClient.live.closeCourseLiveRecord(
            {
              id: this.result.courseLiveRecordId,
            },
          );
        } else {
          data = await axClient.live.startCourseLiveRecord(
            {
              id: this.result.courseLiveRecordId,
            },
          );
        }

        if (data) {
          this.$message.success(`${confirmText}成功`);
          this.getInfo();
        }
      });
    },
    // 获取直播视频记录
    async listLiveRecordVideo() {
      const data = await axClient.live.listLiveRecordVideo({ id: this.result.courseLiveRecordId });
      this.videoLiveList = data;
      this.videoLiveList.forEach((item) => {
        this.$set(item, 'formateSeconds', untils.formateSeconds(Number(item.duration)));
      });
    },
    // 删除视频
    deleteVideo(item) {
      this.$confirm('确定删除该视频？', '删除视频', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const data = await axClient.live.deleteLiveRecordVideo(
          {
            id: item.id,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.listLiveRecordVideo();
        }
      });
    },
    // 获取推流地址
    async getPushUrl() {
      const pushUrl = await axClient.live.getPushUrlSplit({ id: this.result.courseLiveRecordId });
      const pullUrl = await axClient.live.getPullUrl({ id: this.result.courseLiveRecordId });
      this.pushUrl = pushUrl;
      this.pullUrl = pullUrl;
    },
    // 打开推流链接弹窗
    openPushDialog() {
      this.getPushUrl();
      this.dialogVisible = true;
    },
    // 复制推流地址
    copy(data, params) {
      const clipboard = new Clipboard(this.$refs[params], {
        text() {
          return data;
        },
      });
      clipboard.on('success', () => {
        this.$message.success('复制成功');
        // 释放内存
        clipboard.destroy();
        this.dialogVisible = false;
      });
      clipboard.on('error', () => {
        this.$message.error('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
        this.dialogVisible = false;
        this.videoUrlDialogVisible = false;
      });
    },
    // 发送上课通知
    async sendLiveNotice() {
      const data = await axClient.live.sendLiveNotice({ id: this.result.courseLiveRecordId });
      if (data) {
        this.$message.success('发送上课通知成功');
      }
    },
    // 查询直播事件列表
    async listEvent() {
      const data = await axClient.live.listEvent({ id: this.result.courseLiveRecordId });
      if (data) {
        this.eventList = data;
      }
    },
    // 下载视频
    downloadVideo(item) {
      // 用fetch发送请求
      const loadingInstance = Loading.service({ fullscreen: true, background: 'transparent', text: '下载视频中...' });

      fetch(item.liveVideoUrl).then((res) => {
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const arr = item.liveVideoUrl.split('/');
          const filename = arr.pop();
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
          loadingInstance.close();
        });
      }).catch(() => {
        this.$message.error('下载失败');
        loadingInstance.close();
      });
    },
    // 打开上传视频
    openLiveVideoDialog(item) {
      this.activeLiveVideoItem = item;
      this.activeLiveVideoItem.courseLiveRecordId = this.$route.params.id;
      this.liveVideoDialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .btns {
    button {
      margin-right: 15px;
    }
  }
  .video-content,
  .info {
    height: 400px;
  }
  .event-list {
    ::v-deep .el-table {
      height: 377px !important;
    }
  }
}
</style>